import React, { Component } from "react";
import { get as _get, map as _map } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { withRouter } from "../../components/hoc/withRouter";
import { IconDone } from "../../helpers/iconStyles";
import { fetchPriceList } from "../../actions/application";

class Pricing extends Component {

  componentDidMount() {
    const { fetchPriceList } = this.props;

    if (typeof fetchPriceList === "function") { fetchPriceList(); }
  }

  _bookCallBtn = () => {
    return (

      <Link to="/contact-us" className="btn btn-lg btn-primary px-10 text-capitalize">
        <FormattedMessage id="btn.book_a_call" defaultMessage="book a call" />
      </Link>
    );
  }

  _renderPricePlans = () => {
    const { plans } = this.props;

    return (
      <div className="row gx-xl-8">
        {_map((plans), (p, i) => (
          <div className="col-lg-3" key={i}>
            <div className="card-price">
              <p className="heading-06 text-dark mb-6 fw-medium">{_get(p, "name", "")}</p>
              <h4 className="heading-01 fw-medium text-dark mb-1">{_get(p, "currency_symbol", "")} {_get(p, "price", "")}</h4>
              <p className="small fw-bold text-grey-b2">{_get(p, "price_type", "")}</p>

              <ul className="list-unstyled">
                {_map(((p.features || [])), (f, j) => (
                  <li key={j}>
                    <IconDone width="14px" height="12px" color="#0010F7" />
                    {(f || "")}
                  </li>
                ))}
              </ul>

              <div className="mt-auto">
                <Link to="/sign-up" className="btn btn-outline-primary w-100">
                  <FormattedMessage id="btn.sign_up" defaultMessage="Sign Up" />
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    );

  }

  render() {
    const { intl } = this.props;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "enrich.pricing", defaultMessage: "Pricing: Enrich B2B" })}
          </title>
        </Helmet>
        <div className="section-price">
          <div className="container container-1120">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="heading-01 fw-medium text-center mb-lg-9 mb-4">
                  <FormattedMessage id="pricing.title" defaultMessage="pricing" />
                </h1>
                <p className="heading-06 text-grey-63 text-center mb-lg-15 mb-8">
                  <FormattedMessage id="pricing.sub_title" defaultMessage="Each credit is a verified lead, where data has been returned from LinkedIn." />
                </p>
              </div>
            </div>

            {this._renderPricePlans()}

            <div className="row">
              <div className="col-lg-12">
                <h2 className="heading-01 fw-medium text-center mt-lg-15 mb-8">
                  <FormattedMessage id="pricing.call_title" defaultMessage="Not sure about how many leads you'll need?" />
                </h2>
                <p className="heading-04 mb-14 text-center">
                  <FormattedMessage id="pricing.call_sub_title" defaultMessage="Book a call and see if we can help you simplify your workflow and decrease costs." />
                </p>
                <div className="text-center">
                  {this._bookCallBtn()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-price-call">
          <div className="container">

          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  plans: _get(state, "application.priceList.data", [])
});

const mapDispatchToProps = (dispatch) => ({
  fetchPriceList: () => dispatch(fetchPriceList())
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Pricing)));
